@for (severity of severities(); track severity[0]) {
  @if (severity[1] > 0) {
    <div class="severity-item {{ severity[0] }}">
      <div class="signal-bars">
        <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect
            width="3"
            height="12"
            rx="1.5"
            transform="matrix(-1 0 0 1 16 0)"
            [class]="barsFilledWithColorForSevery[severity[0]] >= 4 ? severity[0] : 'inactive'"
          />
          <rect
            width="3"
            height="10"
            rx="1.5"
            transform="matrix(-1 0 0 1 11.6699 2)"
            [class]="barsFilledWithColorForSevery[severity[0]] >= 3 ? severity[0] : 'inactive'"
          />
          <rect
            width="3"
            height="8"
            rx="1.5"
            transform="matrix(-1 0 0 1 7.33984 4)"
            [class]="barsFilledWithColorForSevery[severity[0]] >= 2 ? severity[0] : 'inactive'"
          />
          <rect
            width="3"
            height="6"
            rx="1.5"
            transform="matrix(-1 0 0 1 3.00977 6)"
            [class]="barsFilledWithColorForSevery[severity[0]] >= 1 ? severity[0] : 'inactive'"
          />
        </svg>
      </div>
      @if (showSeverityCount()) {
        <span class="severity-count">{{ severity[1] }}</span>
      }
    </div>
  }
}
